import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import sadCatImg from '@/shared/assets/images/sad-cat.png';
import { Result } from '@/shared/ui';

import { MPRTitle } from '@/features/MPR';

import {
  ToothFullHeadMPRPanel,
  useFullHeadMprAvailability,
} from '@/widgets/FullHeadMPR';
import { MPR2Widget } from '@/widgets/MPR2';

import styles from './ToothMPR.module.scss';

type ToothMPRProps = {
  isMissingThirdMolar: boolean;
  patientID: string;
  reportID: string;
  toothID: string;
  className?: string;
};

export const ToothMPR: FC<ToothMPRProps> = (props) => {
  const { isMissingThirdMolar, patientID, reportID, toothID, className } =
    props;

  const { formatMessage } = useIntl();

  const availability = useFullHeadMprAvailability({ patientID, reportID });

  if (isMissingThirdMolar) {
    return (
      <>
        <MPRTitle />
        <Result
          className={cn(styles.empty, className)}
          icon={
            <img
              src={sadCatImg}
              width={130}
              height={130}
              alt={formatMessage({
                id: 'imgAltText.sadCat',
                defaultMessage: 'Sad cat',
              })}
            />
          }
          text={formatMessage({
            id: 'ToothMPR.noMPR',
            defaultMessage: `There are no MPR for Missing tooth`,
          })}
        />
      </>
    );
  }

  if (availability === 'unavailable') {
    return (
      <>
        <MPRTitle />
        <MPR2Widget toothID={toothID} />
      </>
    );
  }

  return (
    <ToothFullHeadMPRPanel
      className={className}
      patientID={patientID}
      reportID={reportID}
      toothID={toothID}
    />
  );
};
